var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompleteJobi = function SvgCompleteJobi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor',
    "data-name": "Group 10533"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.51h-2.98v-.86A1.61 1.61 0 0 0 14.45 3h-4.9a1.61 1.61 0 0 0-1.57 1.65v.86H5a2.053 2.053 0 0 0-2 2.1V18.9A2.053 2.053 0 0 0 5 21h14a2.053 2.053 0 0 0 2-2.1V7.61a2.053 2.053 0 0 0-2-2.1m-9.45-.93 4.97.07v.86H9.51zm9.95 14.21a.585.585 0 0 1-.5.63H5a.58.58 0 0 1-.5-.63V7.67a.55.55 0 0 1 .5-.58h14a.55.55 0 0 1 .5.58z",
    "data-name": "Path 4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.447 10.722-3.63 3.471-1.264-1.209a.8.8 0 0 0-1.106 1.157l1.818 1.737a.8.8 0 0 0 1.105 0l4.183-4a.8.8 0 0 0-1.106-1.156",
    "data-name": "Path 4849"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompleteJobi);
export default ForwardRef;